var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/travis/build/SouthAmericansSecrets/web/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["partials/contactcontent.es.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\t<div class=\"col-md-12\">\n\t\t <div class=\"row tour-container\">\n\t\t \t\t<div id=\"msg-form\" class=\"col-md-8 col-sm-12\" >\n\t\t\t\t\t<h3>Envíanos un mensaje</h3>\n\t\t\t\t\t<div id=\"contact-form\">\n\t\t\t\t\t\t<div id=\"contact-form-instance\">\n    \t\t\t\t\t\t<div class=\"contact-form\" role=\"form\">\n        \t\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"form-name\" placeholder=\"Nombre\" required=\"required\">\n        \t\t\t\t\t\t<input type=\"email\" class=\"form-control\" id=\"form-email\" placeholder=\"Email\" required=\"required\">\n        \t\t\t\t\t\t<textarea class=\"form-control\" id=\"form-message\" placeholder=\"Mensaje\" rows=\"10\" required=\"required\"></textarea>\n        \t\t\t\t\t\t<button class=\"btn btn-primary btn-lg\" id=\"send-msg\" type=\"submit\"><i class=\"fa fa-paper-plane \"></i>Enviar</button>\n    \t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t </div>\n\t\t\t\t <div class=\"col-md-4 hidden-sm\" style=\"margin-top:15px\">\n\t\t\t\t\t\t<div class=\"banner-right floating-right\">\n\t\t\t \t\t\t\t<div class=\"tour-detail\">\n\t\t\t\t\t \t\t\t<div class=\"tour-info-title\">South Americans' Secrets</div>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t      <p><b>Agencia de turismo y Operador de Tours</b></p>\n\t\t\t\t\t\t      <p><b>Amarilis Pereda & Lucio Hancco</b></p>\n\t\t\t\t\t\t      <p>Cal. Camino Real Mz D lt. 8 San Andrés</p>\n\t\t\t\t\t\t\t  <p>En la Marina Turística, a un lado del Hotel San Agustín - Paracas.\nAbierto desde las 7:30 am hasta la 1:00 pm (Paracas)</p>\n\t\t\t\t\t\t      <p><b>Cel:</b>+51 956-481-002 / +51 947-058-508</p>\n\t\t\t\t\t\t    </div>\n\t\t \t\t\t\t\t</div>\n\t\t\t \t\t\t</div>\n\t\t\t\t </div>\n\t\t </div>\n\t</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["partials/contactcontent.es.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./app/tpl/partials/contactcontent.es.njk
// module id = 54
// module chunks = 50 51 52 53 57 58 59 60 61 62 63 64